const SITE_MEASUREMENT_SUFFIX = '7RR8HQZ0D0'
const APP_MEASUREMENT_SUFFIX = 'MGZBZ8M70L'

const readCookie = (name) => {
  const match = document.cookie.split('; ').find((c) => c.startsWith(name + '='))
  return match ? match.split('=')[1] || '' : ''
}

const readSessionId = (suffix) => {
  const raw = readCookie('_ga_' + suffix)
  const match = raw.match(/^GS2\.\d+\.s(\d+)/) || raw.match(/^GS1\.\d+\.(\d+)\./)
  return match ? match[1] : null
}

export const readGaIds = () => {
  try {
    const ids = {
      ga_client_id: readCookie('_ga').split('.').slice(2).join('.') || null,
      ga_site_session_id: readSessionId(SITE_MEASUREMENT_SUFFIX),
      ga_app_session_id: readSessionId(APP_MEASUREMENT_SUFFIX),
    }
    return Object.keys(ids).reduce((result, key) => {
      if (ids[key]) result[key] = ids[key]
      return result
    }, {})
  } catch (e) {
    return {}
  }
}

export const pushDataLayerEvent = (event, params = {}, timeoutMs = 1500) => new Promise((resolve) => {
  let done = false
  const finish = () => {
    if (done) return
    done = true
    resolve()
  }
  try {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event, ...params, eventCallback: finish, eventTimeout: timeoutMs })
  } catch (e) {
    finish()
    return
  }
  setTimeout(finish, timeoutMs + 200)
})

export const trackSignUpOnce = (userKey, method) => {
  const key = `popex_signup_sent_${userKey}`
  try {
    if (localStorage.getItem(key)) return Promise.resolve()
    localStorage.setItem(key, '1')
  } catch (e) {}
  return pushDataLayerEvent('sign_up', { method })
}
